module.exports = __webpack_public_path__ + "img/93963.fbea765e.svg";